@if (state$ | async; as state) {
	@if (state && !state.inlineAttached) {
		<app-notice-session-chat
			[noticeSession]="state.noticeSession"
			[inlineContext]="false"
			[viewerMode]="!!state.viewerMode"
			[readerRoomId]="state.readerRoomId ?? null"></app-notice-session-chat>
	}
}
